import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import customProvider from '@/data-provider/customProvider';
import { Keyword } from '@ilteducation/content-ref-data-types';
import { ImageV1 } from '@ilteducation/content-registry-types';
import { useBabelfish } from '@/comp/use-babelfish';
import DownloadKeywordStats from '@/components/keywords/DownloadKeywordStats.vue';

type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {


const { lokaliseProjectId } = useBabelfish();

const images = ref<Record<string, ImageV1>>({});
const dataTable = ref();

watch(
  () => dataTable.value?.items,
  (items: Keyword[]) => {
    if (!items || items.length === 0) {
      return;
    }
    const imageIds = items.map((item) => item.imageId).filter((id) => id && !images.value[id]) as string[];
    customProvider()
      .getList('content-image', {
        filter: { id: imageIds },
        pagination: { perPage: 100, page: 1 },
        sort: [],
      })
      .then((response) => {
        response.data?.forEach((image: ImageV1) => {
          images.value[image.id] = image;
        });
      });
  },
);

const lokaliseLink = (id: string) => {
  if (!id) {
    return;
  }
  return `https://app.lokalise.com/project/${lokaliseProjectId.value}/?view=multi&search=${id}::altText`;
};

const fields = [
  {
    source: 'id',
    link: 'edit',
    sortable: false,
  },
  {
    source: 'key',
    label: 'Key',
    sortable: true,
  },
  {
    source: 'imageId',
    label: 'Has image',
    type: 'boolean',
    sortable: true,
  },
  {
    source: 'image.altText',
    label: 'Image Alt Text',
  },
  {
    source: 'active',
    type: 'boolean',
    sortable: true,
  },
  {
    source: 'applications',
    type: 'array',
    label: 'Visible in',
  },
];

const filters = [
  {
    source: 'active',
    type: 'boolean',
    attributes: {
      multiple: true,
    },
  },
  {
    source: 'applications',
    type: 'select',
    label: 'Visible in',
    attributes: {
      multiple: true,
      choices: ['manabua', 'learn-it'],
    },
  },
];

return { __sfc: true,lokaliseProjectId, images, dataTable, lokaliseLink, fields, filters, DownloadKeywordStats }
}

})